import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { availableLanguages } from '../components/api';
import { AppDispatch, RootState } from '../redux';
import { fetchPageContent } from '../redux/pageContentSlice';

// export const usePageContent = (path: string | null, thisPage: any, serverData?: any) => {
//   if(path != null){
//     const dispatch = useDispatch<AppDispatch>();

//     // 🧠 Normalize path to match Redux key naming
//     const pathParts = path.split("/");
//     const possibleLang = pathParts[1];
//     const isLanguagePrefix = availableLanguages.includes(possibleLang);
//     const pathWithoutLang = isLanguagePrefix ? path.replace(`/${possibleLang}`, "") : path;

//     const trimmedPath = pathWithoutLang.startsWith("/") ? pathWithoutLang.slice(1) : pathWithoutLang;
//     let newPath = trimmedPath === "" ? "home" : trimmedPath;
//     if (newPath.endsWith("/")) newPath = newPath.slice(0, -1);

//     // 🧩 Select content from store
//     const content = useSelector((state: RootState) => state.pageContent.content[newPath]);
//     const loading = useSelector((state: RootState) => state.pageContent.loading);
//     const error = useSelector((state: RootState) => state.pageContent.error);

//     useEffect(() => {
//       // 🧠 Always check for path changes, even if content is null (forces re-fetch)
//       if (!newPath) return;

//       // 🧠 Ensure we don't miss updates when serverData is passed only once
//       if (serverData && !content) {
//         dispatch({
//           type: "pageContent/fetchPageContent/fulfilled",
//           payload: { newPath, data: serverData },
//         });
//       } 
//       // ✅ Always re-fetch if no server data or empty content
//       else if (!serverData && !content && !loading) {
//         dispatch(fetchPageContent(newPath));
//       }
//     }, [newPath, dispatch, serverData]); // ✅ removed 'content' to prevent blocking updates

//     return { content, loading, error };
//   }else{
//     return {null, false, null};
//   }
// };
export const usePageContent = (path: string | null, thisPage: any, serverData?: any) => {
    const dispatch = useDispatch<AppDispatch>();

    // 1. Move the path normalization logic outside the conditional to keep it stable
    let newPath = "";
    if (path) {
        const pathParts = path.split("/");
        const possibleLang = pathParts[1];
        const isLanguagePrefix = availableLanguages.includes(possibleLang);
        const pathWithoutLang = isLanguagePrefix ? path.replace(`/${possibleLang}`, "") : path;

        const trimmedPath = pathWithoutLang.startsWith("/") ? pathWithoutLang.slice(1) : pathWithoutLang;
        newPath = trimmedPath === "" ? "home" : trimmedPath;
        if (newPath.endsWith("/")) newPath = newPath.slice(0, -1);
    }

    // 2. Selectors must be called at the top level (not inside if-else)
    // We pass a fallback or check for newPath inside the selector
    const content = useSelector((state: RootState) => newPath ? state.pageContent.content[newPath] : null);
    const loading = useSelector((state: RootState) => state.pageContent.loading);
    const error = useSelector((state: RootState) => state.pageContent.error);

    useEffect(() => {
        // 3. Logic Gate: Only run if we have a path
        if (!newPath) return;

        if (serverData && !content) {
            dispatch({
                type: "pageContent/fetchPageContent/fulfilled",
                payload: { newPath, data: serverData },
            });
        } 
        else if (!serverData && !content && !loading && !error) {
            dispatch(fetchPageContent(newPath));
        }
    }, [newPath, dispatch, serverData, content, loading, error]);

    // 4. Return the standard object even if path was null
    return { 
        content: path ? content : null, 
        loading: path ? loading : false, 
        error: path ? error : null 
    };
};
// export const usePageContent = (path: string, thisPage: any, serverData?: any) => {
//     const dispatch = useDispatch<AppDispatch>();
//     let pagePath = path
//     const pathParts = pagePath.split('/');
//     const possibleLang = pathParts[1]; // First part after the initial slash
//     const isLanguagePrefix = availableLanguages.includes(possibleLang); // Check if the first part is a language code (e.g., "en", "ar")
//     const pathWithoutLang = isLanguagePrefix ? pagePath.replace(`/${possibleLang}`, '') : pagePath;
    
//     // pathWithoutLang.startsWith('/') ? pathWithoutLang.slice(1) : pathWithoutLang
//     // let newPath = pathWithoutLang === '/' ? 'home/' : pathWithoutLang;
//     // if (newPath.endsWith('/')) { newPath = newPath.slice(0, -1) }
    
//     const trimmedPath = pathWithoutLang.startsWith('/') ? pathWithoutLang.slice(1) : pathWithoutLang
//     let newPath = trimmedPath === '' ? 'home' : trimmedPath
//     if (newPath.endsWith('/')) newPath = newPath.slice(0, -1)
//     // console.log("Path: ", newPath)
//     const content = useSelector((state: RootState) => 
//     {
//         // console.log("State: ")
//         // console.log(state.pageContent.content)
//         return(
//             state.pageContent.content[newPath]
//         )
//     });
//     const loading = useSelector((state: RootState) => state.pageContent.loading);
//     const error = useSelector((state: RootState) => state.pageContent.error);
//     useEffect(() => {
//         if(thisPage == "" || thisPage == null){
//             if (serverData && !content) {
//                 dispatch({ type: 'pageContent/fetchPageContent/fulfilled', payload: { newPath, data: serverData } }); // console.log("From the Cash")
//             } else if (!content) { dispatch(fetchPageContent(newPath)) /* console.log("From the internet") */ }
//         }
//     }, [newPath, content, serverData, dispatch]);
//     return { content, loading, error };
// };